import React, { type FunctionComponent } from 'react'
import { campaignStatusReadable } from '../../../lib/campaignStatus'

type Props = {
  status: CharityStatusType | CampaignStatusType
  campaignStartDate?: string
}

export const Status: FunctionComponent<Props> = ({ status, campaignStartDate }) => {
  if (campaignStartDate) {
    return (
      <div className="font-bold capitalize">
        {campaignStatusReadable(status as CampaignStatusType, new Date(campaignStartDate)).toLowerCase()}
      </div>
    )
  }

  return <div className="font-bold capitalize">{status.toLowerCase()}</div>
}
